export const defaultCategoriesModelData = {
  activeCategoryId: null
};

export const defaultSortingModelData = {
  sortName: null,
  sortDir: null,
  isLoading: false
};

export const SortDir = {
  DESC: `desc`,
  ASC: `asc`,
  NONE: `none`
};

export const ActionType = {
  CHANGE_CATEGORY: `CHANGE_CATEGORY`,
  CHANGE_SORTING_DIRECTION: `CHANGE_SORTING_DIRECTION`,
  ACTIVATE_SORTING_BUTTON: `ACTIVATE_SORTING_BUTTON`
};

export const CATALOG_PAGE_HREF = `/catalog`;

export const PAGE_KEY = `page`;
export const LIMIT_KEY = `limit`;
export const CATEGORY_ID_KEY = `category_id`;
export const SORT_BY_KEY = `sort`;
